
export default {
  productData: {
    serialNumber: 'DA-HMUL-002',
    name: 'Holzbalkendecken mit Unterdecken an Lattung | Aufbau 2',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 50',
          value: 'w-50'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolledämmplatte MW<br>(<i>s‘</i> ≤ 10 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'm-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 45 kg/m<sup>2</sup>), ggf. Rieselschutz' },
          output: '30',
          value: 'scsb-30'
        },
        {
          type: 'woodenPanel',
          title: { de: 'Holzwerkstoffplatte HW' },
          output: '22',
          value: 22
        },
        {
          type: 'supportingStructure',
          title: { de: 'Balken oder Stegträger' },
          output: '220',
          value: 'bs-220'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Hohlraumdämpfung' },
          output: '100',
          value: 'h-100'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Lattung' },
          output: '24',
          value: 'ba-24'
        },
        {
          type: 'suspendedCeiling',
          title: { de: 'Gipsplatte GK' },
          output: '12,5',
          value: 'g-12.5'
        }
      ],
      sum: {
        output: '378,5', value: 378.5
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '46 (2)', value: 46
      },
      soundReductionIndex: { // Rw
        output: '67 (-4; -11)', value: 67
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,28', value: 0.28
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '213,3 [kg/m²]'
      }
    }
  },
  image: 'da-hmul-002.png',
  pdf: 'Holzbalkendecken-mit-Unterdecke-an-Lattung-Aufbau-2-DA-HMUL-002-Rev03.pdf'
}
